<template lang="Disponibilidad">
    <div>

        <v-select
            :items="modalidades"
            v-model="modalidad"
            label="Seleccione Modalidad"
            item-text="nombre"
            item-value="modalidad"
            return-object
        ></v-select>
        <v-select
            :items="dias"
            v-model="dia"
            label="Seleccione Dia"
            item-text="dia"
            item-value="DiaSemana"
            return-object
        ></v-select>

        <v-menu
            ref="menuRef"
            v-model="menuHorario"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="horario"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
        >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                label="Seleccione hora"
                v-model="horario"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                 v-bind="attrs"
            v-on="on"
            ></v-text-field>
        </template>
            <v-time-picker v-model="horario" @change="$refs.menuRef.save(horario)" format="24hr"></v-time-picker>
        </v-menu>
    </div>
</template>
<script>
export default {
    data() {
        return {
            dia:null,
            horario:null,
            modalidad:null,
            menuHorario:false,
            dias:[
                {dia:"Lunes", DiaSemana:2},
                {dia:"Martes", DiaSemana:3},
                {dia:"Míercoles", DiaSemana:4},
                {dia:"Jueves", DiaSemana:5},
                {dia:"Viernes", DiaSemana:6},
                {dia:"Sábado", DiaSemana:7},
            ],
            modalidades:[
                {nombre:"Semipresencial", modalidad:'S'},
                {nombre:"Distancia", modalidad:'D'},
            ]
        }
    },methods: {
        
    },
}
</script>
<style lang="">
    
</style>